<template>
  <main class="app-container">
    <review-form></review-form>
  </main>
</template>

<script>
import ReviewForm from "../components/ReviewForm.vue";

export default {
  name: "home",
  components: {
      ReviewForm
  }
};
</script>


<style lang="scss" scoped>


</style>
